var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpGoodscolorchangeNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#96A2B1;}\r\n\t.st2{fill:#5B6673;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1024,
    height: 1024
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368,64c-89.3,0.1-177.2,22.1-256,64l64,256l64,384h64l-64.9-394.5l-0.4-2.5l-0.6-2.5l-51.2-205 c116.1-47.4,246.2-47.4,362.3,0l-47.2,189c23-11.1,47.2-19.5,72.2-24.9L624,128C545.2,86.1,457.3,64.1,368,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M496,924.6V944c0,8.8-7.2,16-16,16H256c-8.8,0-16-7.2-16-16V832h64v80h128v-30.2 C451.6,898.5,473,912.9,496,924.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347,768H240v64h144.9C369.8,812.2,357.1,790.7,347,768z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 644.8,
    cy: 445.3,
    rx: 34.9,
    ry: 34.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 772.6,
    cy: 491.1,
    rx: 34.9,
    ry: 34.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 517,
    cy: 491.1,
    rx: 34.9,
    ry: 34.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 458.9,
    cy: 582.7,
    rx: 34.9,
    ry: 34.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M645,384c54-0.1,106.7,16.4,151,47.3c43.9,30.4,77.1,73.8,95.1,124l0,0l0,0c9.3,25.8,5,54.5-11.4,76.5 c-13.6,18.3-33.9,30.4-56.5,33.6l-2.6,0.3c-6.7,0.8-13.4,1.3-20.1,1.3c-16.8,0-31.2-2.6-45-5.1c-12.1-2.2-23.6-4.3-35.4-4.3 c-13.8-0.1-27.4,3.5-39.4,10.3c-20.2,11.5-35.7,31.7-44.8,58.3l-0.1,0.2l-0.1,0.2c-4.7,14-7.6,28.5-8.6,43.3v0.2v0.2 c-2.5,40.3,12.6,81.3,42.7,115.3c1,1.1,1.5,2.5,1.5,3.9c0,3.5-3.3,6.4-7.4,6.4h-19.4c-34.9,0.1-69.5-6.8-101.7-20.2 c-30.9-12.9-59.1-31.6-82.9-55.1c-23.7-23.2-42.6-50.9-55.7-81.4c-27.1-63.4-27.1-135.2,0-198.6c13.1-30.5,32-58.1,55.7-81.4 c23.8-23.5,52-42.2,82.9-55.1c32.2-13.4,66.8-20.3,101.7-20.2H645 M645,320h-0.3C465.3,320,320,463.3,320,640s145.3,320,324.6,320 H664c39.3,0,71.3-31.4,71.4-70.2c0-17.1-6.2-33.7-17.6-46.5c-18.8-21.2-28.2-45.6-26.8-68.8c0.7-9.3,2.5-18.6,5.5-27.5 c2.8-8.2,7.9-18.8,15.9-23.4c2.1-1.2,3.9-1.8,7.8-1.8c6,0,14.3,1.5,24,3.2c15.1,2.7,33.9,6.1,56.4,6.1c9.5,0,18.9-0.6,28.3-1.8 c1.2-0.2,2.3-0.3,3.5-0.5c81.7-11.9,138.1-86.9,126-167.4c-1.4-9.4-3.8-18.7-7-27.6C905.6,405.7,782.7,320,645,320z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpGoodscolorchangeNormal);
export default __webpack_public_path__ + "static/media/hp_goodscolorchange_normal.5603986c667fdd99d3a53db8528b10b4.svg";
export { ForwardRef as ReactComponent };